import { useEffect, useState } from 'react'
import {
  hideVenueNavTooltip,
  setVenueNavTooltipOpen,
  subscribeVenueNavTooltipOpen,
} from 'src/utils/venueNavTooltip'

/** Only one venue top-nav tooltip open at a time. */
export const useVenueNavTooltipOpen = id => {
  const [open, setOpen] = useState(false)

  useEffect(
    () =>
      subscribeVenueNavTooltipOpen(current => {
        setOpen(current === id)
      }),
    [id],
  )

  const onVisibleChange = next => {
    if (next) setVenueNavTooltipOpen(id)
    else hideVenueNavTooltip(id)
  }

  return [open, onVisibleChange]
}
